<template>
  <div id="app">
    <div id="background">
      <div class="ui dimmable dimmed segment">
        <div class="ui simple dimmer"></div>
        <mosaic></mosaic>
      </div>
    </div>
    <div id="content">
      <div>
        <site v-for="link in links" :logo="link.logo" :link="link.link">{{link.name}}</site>
      </div>
    </div>
  </div>
</template>

<script>
import Mosaic from 'components/Mosaic'
import Site from 'components/Site'

import imgFacebook from 'assets/facebook.png'
import imgDiscord from 'assets/discord.png'
import imgTeamspeak from 'assets/teamspeak.png'
import imgForum from 'assets/forum.png'
import imgTwitter from 'assets/twitter.png'
import imgYouTube from 'assets/youtube.png'
import imgSteam from 'assets/steam.png'

export default {
  name: 'app',
  components: {
    Mosaic,
    Site
  },
  data () {
    return {
      links: [
        { logo: imgFacebook, link: 'https://www.facebook.com/groups/otaku974.re/', name: 'Facebook' },
        { logo: imgDiscord, link: 'https://discord.gg/gqxxVFW', name: 'Discord' },
        { logo: imgTeamspeak, link: 'ts3server://otaku974.re/?port=9987&nickname=RandomOtaku', name: 'TeamSpeak' },
        { logo: imgForum, link: 'https://forum.otaku974.re/', name: 'Forum' },
        { logo: imgTwitter, link: 'https://twitter.com/otaku974/', name: 'Twitter' },
        { logo: imgYouTube, link: 'https://www.youtube.com/user/Otaku974reunion/', name: 'YouTube' },
        { logo: imgSteam, link: 'http://steamcommunity.com/groups/OTAKU974/', name: 'Steam' }
      ]
    }
  }
}
</script>

<style>
@import 'assets/semantic.css';
@import url('https://fonts.googleapis.com/css?family=Roboto');

body {
  font-family: 'Roboto', sans-serif;
}
</style>

<style scoped>
#background {
  height: 100vh;
  overflow: hidden;
  position: fixed;
  z-index: -100;
}

#content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

#content > div {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// App.vue?2272a9dc